import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function PravoEvropskeUnije() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Pravo Evropske unije" />
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Pravo Evropske unije</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Pravo Evropske unije
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 4
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Pravo Evropske Unije je pružiti studentima
                razumijevanje Evropske Unije, njene organizacije, pravnih akata
                Unije, njenih institucija i njihovih međusobnih odnosa. U okviru
                predavanja će, osim teorijske nastave, biti izvedena i praktična
                nastava sa vježbama na kojima će studentima biti omogućeno bolje
                razumijevanje nekih važnih aspekata vezanih za funkcionisanje
                same Evropske Unije kao i razumijevanje važnih aspekata
                praktičnog organizacionog djelovanja sistema javne uprave na
                centralnom nivou.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Ovaj predmet će omogućiti studentima da razumiju Evropsku Uniju,
                njenu pravnu tekovinu i uticaj Evropske Unije na pravni sistem
                država koje pristupaju Evropskoj Uniji, kao što je i sama Crna
                Gora. Studenti će savladati pravni sistem Evropske Unije sa
                posebnim osvrtom na unutrašnje tržište, zaštitu životne sredine,
                budžet Evropske Unije i mnoge druge značajne aspekte. Stečena
                znanja će pružiti studentima uvid u osnovne karakteristike
                pravnog sistema Evropske unije, evoluciju evropskih
                integracionih procesa, načine donošenja odluka i kapacitet
                efikasnosti Evropske unije na spoljno-političkom planu.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Istorijski razvoj Evropske unije, ideje o ujedinjenju Evrope,
                međunarodna i regionalna dešavanja nakon II svjetskog rata,
                Evropska zajednica za ugalj i čelik, evropska odbrambena
                zajednica, evropska ekonomska zajednica, evropska zajednica za
                atomsku energiju, proširenje Evropske unije (I, II, III, IV, V,
                VI, VII talas proširenja EU), institucionalni okvir Evropske
                unije (Komisija Evropske unije, Evropski savjet, Savjet
                ministara, Evropski parlament, Revizorski sud, Evropska
                centralna banka, komitet regiona, ekonomsko-socijalni komitet,
                evropska investiciona banka), izvori prava Evropske unije,
                ciljevi, nadležnosti i načela Evropske unije, pravosudni sistem
                Evropske unije, saradnja u oblasti pravosuđa i unutrašnjih
                poslova, zajednička spoljna i bezbjedonosna politika, unutrašnje
                tržište Evropske unije.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja, vježbe,
                konsultacije, pismene provjere znanja (kolokvijumi),
                individualni rad studenata (seminarski i domaći radovi, referati
                i sl.) kao i grupno učestvovanje studenata na savlađivanju
                određenih tematskih jedinica.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P</td>
                    <td>
                      Ideje o ujedinjenju Evrope, međunarodna i regionalna
                      dešavanja nakon II svjetskog rata
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P</td>
                    <td>
                      Evropska zajednica za ugalj i čelik, evropska odbrambena
                      zajednica, evropska ekonomska zajednica, evropska
                      zajednica za atomsku energiju
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P</td>
                    <td>
                      Proširenje Evropske unije (I, II, III, IV, V, VI, VII
                      talas proširenja EU)
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P</td>
                    <td>Ugovor o ustavu Evropske unije</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>2P</td>
                    <td>
                      Komisija Evropske unije: sastav, izbor članova, rad,
                      ovlašćenja
                    </td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P</td>
                    <td>Evropski savjet: predsjednik, nadležnosti</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P</td>
                    <td>
                      Savjet ministara: nadležnosti, način donošenja odluka
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P</td>
                    <td>Evropski parlament: nadležnosti i ovlašćenja</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P</td>
                    <td>Revizorski sud: zaduženja</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P</td>
                    <td>
                      Evropska centralna banka, komitet regiona,
                      ekonomsko-socijalni komitet, evropska investiciona banka
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P</td>
                    <td>
                      Izvori prava Evropske unije: primarno i sekundarno
                      zakonodavstvo
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P</td>
                    <td>Načela evropskog prava</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P</td>
                    <td>Pravosudni sistem Evropske unije</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 2č / 1.3h</td>
                            <td>Ukupno: 40h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2č / 1.3h</td>
                            <td>Nastava + završni ispit: 30h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i ovjera semestra: 3h</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Priprema i polaganje popravnog ispita: 7h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PravoEvropskeUnije;
